/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AltroCasoTariffarioDTO } from './altro-caso-tariffario-dto';
import { SchedaTariffarioDTO } from './scheda-tariffario-dto';
import { ColonnaTariffarioDTO } from './colonna-tariffario-dto';


export interface TariffarioMensaDTO { 
    numero_pasti_per_contributo?: number;
    esenti_esclusi_conteggio_fratelli?: boolean;
    colonne?: Array<ColonnaTariffarioDTO>;
    schede?: Array<SchedaTariffarioDTO>;
    altri_casi?: Array<AltroCasoTariffarioDTO>;
}

